import { useState } from 'react';

type ImageWithFallbackProps = {
  src: string;
  alt: string;
  className: string;
  dataTestId?: string;
};

const ImageWithFallback = ({ src, alt, className, dataTestId }: ImageWithFallbackProps) => {
  const [isError, setIsError] = useState(false);

  if (isError) return null; // Do not render the img if an error occurs

  return <img alt={alt} className={className} data-testid={dataTestId} src={src} onError={() => setIsError(true)} />;
};

export default ImageWithFallback;
